// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_3FoS5","inline":"_1-Y07","block":"efMxC","fullWidth":"Xu0-W","trigger":"_2pXa7","button":"UBwSa","icon":"_2Tx2Y","icon--disabled":"_2JPnT"};